import LANGUAGES_LIST from './languages.json';

const LANGUAGES: Record<string, string> = LANGUAGES_LIST;

/** Our name for the locale, else the browser's English name, else the raw code - never blank. */
export function getLanguageLabel(locale: string): string {
    if (LANGUAGES[locale]) {
        return LANGUAGES[locale];
    }
    try {
        return new Intl.DisplayNames(['en'], { type: 'language' }).of(locale) || locale;
    } catch {
        return locale;
    }
}
